import React, { useEffect, useMemo, useState } from 'react';
import './index.scss';
import { Modal, SearchBox } from 'tea-component';
import MenuTab from '../../../components/menuTab';
import type { IGetTableInfoDto } from '@dbl/services/dataSource';
import { CustomColumn } from '@/pages/datalab/pages/Multidimensional/Analysis/interface';
import DefineField from '../../../DefineField';
import MenuTabCustom from '../../../components/menuTabCustom';
import {getLocalText, useDblIntl} from "@/pages/datalab/utils/utils";
import { ITableJoinRelation } from "@/pages/datalab/pages/Multidimensional/Analysis/components/HeaderData/interface";
import useDragDropPageDetail
  from "@/pages/datalab/pages/Multidimensional/Analysis/components/DetailModal/useDragDropPageDetail";

export default function TableFieldList(props: any) {
  const {
    namespace,
    isShowCustomColumns,
    customColumns,
    dataTables,
    dataTableJoinRelations,
  }: {
    namespace: string;
    isShowCustomColumns: boolean;
    customColumns: CustomColumn[];
    dataTables: IGetTableInfoDto[];
    dataTableJoinRelations: ITableJoinRelation[];
  } = props;
  const {dblFormatMessage: multiFormatMessage, commonFormatMessage, isEn} = useDblIntl("multi");
  const [curTables, setCurTables] = useState<IGetTableInfoDto[]>([]);
  const [searchValue, setSearchValue] = useState<string>('');
  const [curCustomColumns, setCurCustomColumns] = useState<CustomColumn[]>(customColumns || []);

  const {openModal, ...detailProps} = useDragDropPageDetail({isSingle: dataTables?.length === 1});
  
  useEffect(() => {
    searchValue ? Search(searchValue) : setCurTables(dataTables);
  }, [JSON.stringify(dataTables)]);

  useEffect(() => {
    setCurCustomColumns(customColumns || []);
    Search(searchValue); // 如果在搜索的时候删除某一个字段,则可以通过这个返回搜索现场
  }, [customColumns]);

  function Search(value: string) {
    setSearchValue(value);
    value = value.toLowerCase();
    if (value) {
      const searchTables: IGetTableInfoDto[] = JSON.parse(JSON.stringify(dataTables));
      (searchTables || []).forEach((tableInfo: IGetTableInfoDto) => {
        {
          if (tableInfo.column_class_list) {
            for (let j = 0;j < tableInfo.column_class_list.length;j++) {
              const colunmClassList = tableInfo.column_class_list[j];
              if (colunmClassList.columns) {
                for (let k = 0;k < colunmClassList.columns.length;k++) {
                  const columns = colunmClassList.columns[k];
                  if (columns.column_display.toLowerCase().indexOf(value) === -1 && columns.column_name.toLowerCase().indexOf(value) === -1) {
                    colunmClassList.columns.splice(k, 1);
                    k = k - 1;
                  }
                }
                if (colunmClassList.columns.length === 0) {
                  tableInfo.column_class_list.splice(j, 1);
                  j = j - 1;
                }
              }
            }
          }
        }
      });

      setCurTables(searchTables);

      setCurCustomColumns(
        (customColumns || []).filter((item) => item.name_cn.toLowerCase().indexOf(value) !== -1 || item.name_en.toLowerCase().indexOf(value) !== -1),
      );
    } else {
      setCurTables(dataTables);
      setCurCustomColumns(customColumns);
    }
  }

  const showNoData = useMemo(() => {
    let showNoData = false;
    try {
      (curTables || []).forEach((tableInfo: IGetTableInfoDto) => {
        (tableInfo.column_class_list || []).forEach((colunmClassList) => {
          if (colunmClassList.columns.length > 0) {
            showNoData = false;
            throw new Error();
          }
        });
      });
      if (curCustomColumns.length > 0) {
        showNoData = false;
        throw new Error();
      }

      showNoData = true;
    } catch (_) {}

    return showNoData;
  }, [curTables, curCustomColumns]);

  function showFieldDefine(e: any, customColumn?: CustomColumn) {
    const column = customColumn
      ? (customColumns || []).find((item) => item.id === customColumn.id) ?? {}
      : {};
    e.stopPropagation();
    const modal = Modal.show({
      className: 'add-field dbl-analysis-add-field-model',
      size: 'l',
      caption: column?.name_en ? multiFormatMessage("edit_field") : multiFormatMessage("add_field"),
      children: (
        <DefineField
          fieldValue={column}
          customColumns={customColumns}
          dataTables={dataTables}
          dataTableJoinRelations={dataTableJoinRelations}
          onConfirm={(customColumn: CustomColumn) => {
            props.dispatch({
              type: `${namespace}/updateCustomColumn`,
              payload: { updateColumn: customColumn},
            });
            modal.destroy();
          }}
          onClose={() => modal.destroy()}
          multiFormatMessage={multiFormatMessage}
          commonFormatMessage={commonFormatMessage}
          isEn={isEn}
        />
      ),
      onClose: () => modal.destroy(),
    });
  }

  return curTables.length > 0 ? (
    <>
      <SearchBox className="left-search" value={searchValue} onChange={Search} placeholder={commonFormatMessage("search")} />
      {showNoData ? (
        <div style={{ textAlign: 'center', height: '100%', marginTop: '20%' }}>{commonFormatMessage("search_nothing")}</div>
      ) : (
        <div className="left-data">
          {isShowCustomColumns ? (
            <MenuTabCustom
              {...props}
              customColumns={curCustomColumns}
              deleteField={(customColumn: CustomColumn) => {
                const newCustomColumns = (customColumns || []).filter((item) => item.name_cn !== customColumn.name_cn);
                // props.dispatch({
                //   type: `${namespace}/save`,
                //   payload: { customColumns: newCustomColumns, calculateHashForAnalysis: true },
                // });
                props.dispatch({
                  type: `${namespace}/deleteConditionByCustomColumn`,
                  payload: {customColumns: newCustomColumns, deleteCustomColumn: customColumn },
                });
              }}
              showFieldDefine={showFieldDefine}
              updateColumn={(column: CustomColumn) => {
                
  
                props.dispatch({
                  type: `${namespace}/updateCustomColumn`,
                  payload: { updateColumn: column},
                });
                
              }}
            />
          ) : null}

          {(curTables || []).map((tableInfo: IGetTableInfoDto) => (
            <MenuTab
              {...props}
              curCustomColumns={curCustomColumns}
              key={tableInfo.table_id + tableInfo.table_code}
              tableInfo={tableInfo}
              searchValue={searchValue}
              detailProps={detailProps}
              openDetailModal={() => {
                const tableNames = curTables.map(item => getLocalText(isEn, item?.customize_name, item?.customize_name_en, item?.table_name));
                
                openModal({
                  tableIds: curTables.map(item => item.table_id),
                  tableInfos: dataTableJoinRelations,
                  dataTables,
                  customColumns: curCustomColumns,
                  resetProps: {
                    isSingle: curTables.length === 1,
                    title: (<div dangerouslySetInnerHTML={{__html: tableNames.join('<span style="color: #838697;margin-left: 4px; margin-right: 4px">&</span>')}} />)
                  }
                });
              }}
              deleteTab={() => {
                // 删除数据表, 图表设置也要删除, dataTableJoinRelations 也要修改, 要考虑自关联情况下的删除
                let tables = [];
                let relationTables = [];
                if (curTables.length === 2 && curTables[0].table_id === curTables[1].table_id) { // 说明是自关联情况
                  curTables[0].table_code = 't0';
                  curTables[0].only_one_table = true;
                  tables = [curTables[0]];
                  dataTableJoinRelations[0].on = [];
                  dataTableJoinRelations[0].table_code = 't0';
                  dataTableJoinRelations[0].only_one_table = true;
                  relationTables = [dataTableJoinRelations[0]];
                } else {
                  tables = curTables.filter(table => table.table_id !== tableInfo.table_id);
                  tables = tables?.map((item, index) => {
                    item.table_code = `t${index}`;
                    item.only_one_table = tables.length === 1;
                    return item;
                  });
                  relationTables = dataTableJoinRelations.filter(table => table.table_id !== tableInfo.table_id);
                  relationTables =  relationTables?.map((item, index) => {
                    item.table_code = `t${index}`;
                    item.only_one_table = tables.length === 1;
                    return item;
                  });
                }
                props.dispatch({
                  type: `${namespace}/save`,
                  payload: {
                    dataTables: tables,
                    dataTableJoinRelations: relationTables,
                    isOpenSelfJoin: false,
                  },
                });
                props.dispatch({
                  type: `${namespace}/filterConditionByTable`,
                  payload: {
                    tables, // 被保留下来的数据表
                    table_ids: [tableInfo.table_id],
                    excludeTable: true,
                    isClearRelations: true,
                    tableInfo,
                  },
                });
                
              }}
              multiFormatMessage={multiFormatMessage}
              commonFormatMessage={commonFormatMessage}
              isEn={isEn}
            />
          ))}
        </div>
      )}
    </>
  ) : null;
}
